import React, { useEffect, useState } from "react";

import SponsorModal from "../SponsorModal/SponsorModal";
import { FetchSponsors } from "../../api/FetchSponsors";
import { DeleteSponsor } from "../../api/DeleteSponsor";
import { ModifySponsor } from "../../api/ModifySponsor";
import Modal from "../Modal/Modal";

const SponsorsTab = ({ gatheringID }) => {
  const [sponsors, setSponsors] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedSponsor, setSelectedSponsor] = useState(null);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [sponsorToDelete, setSponsorToDelete] = useState(null);

  const fetchSponsorsData = async () => {
    const sponsorsData = await FetchSponsors(gatheringID);
    setSponsors(sponsorsData);
  };

  // Fetch sponsors when gatheringID changes
  useEffect(() => {
    console.log("Fetching sponsors for gatheringID:", gatheringID); // Log to confirm it's working
    fetchSponsorsData(); // Call to fetch sponsors initially when the component loads or gatheringID changes
  }, [gatheringID]); // Re-fetch when the gatheringID changes

  const handleAddSponsor = () => {
    setSelectedSponsor(null); // Reset selected sponsor for new sponsor
    setIsModalVisible(true);
  };

  const handleEditSponsor = (sponsor) => {
    setSelectedSponsor(sponsor);
    setIsModalVisible(true);
  };

  const reorderSponsor = (index, delta) => {
    const updated = [...sponsors];
    const swapIndex = index + delta;
    if (swapIndex < 0 || swapIndex >= updated.length) return;
    [updated[index], updated[swapIndex]] = [updated[swapIndex], updated[index]];
    const reRanked = updated.map((s, i) => ({ ...s, rank: i + 1 }));
    setSponsors(reRanked);
  };

  const saveOrder = async () => {
    try {
      await Promise.all(
        sponsors.map((s) => ModifySponsor(gatheringID, s.id, { rank: s.rank }))
      );
      alert("Sponsor order saved.");
    } catch (err) {
      console.error("Error saving sponsor order:", err);
      alert("Failed to save sponsor order.");
    }
  };

  const confirmDeleteSponsor = (sponsor) => {
    setSponsorToDelete(sponsor);
    setIsConfirmOpen(true);
  };

  const handleConfirmModal = async () => {
    if (!sponsorToDelete) return;
    try {
      await DeleteSponsor(sponsorToDelete.id, gatheringID);
      setSponsors((prev) => prev.filter((s) => s.id !== sponsorToDelete.id));
    } catch (err) {
      console.error(err);
      alert("Failed to delete sponsor.");
    } finally {
      setIsConfirmOpen(false);
      setSponsorToDelete(null);
    }
  };

  const handleCloseModal = () => {
    setIsConfirmOpen(false);
    setSponsorToDelete(null);
  };

  return (
    <div className="input-container">
      <h2 style={{ fontSize: "24px", fontWeight: "600" }}>Sponsors</h2>
      <button onClick={handleAddSponsor} style={styles.addButton}>
        Add Sponsor
      </button>
      <div>
        {sponsors && sponsors.length > 0 ? (
          <>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.tableHeader}>Name</th>
                  <th style={styles.tableHeader}>Change Order</th>

                  <th style={styles.tableHeader}>Edit</th>
                  <th style={styles.tableHeader}>Delete</th>
                </tr>
              </thead>
              <tbody>
                {sponsors.map((sponsor, i) => (
                  <tr key={sponsor.id}>
                    <td style={styles.tableCell}>{sponsor.name}</td>
                    <td style={styles.tableCell}>
                      <button
                        onClick={() => reorderSponsor(i, -1)}
                        disabled={i === 0}
                        style={styles.arrowButton}
                      >
                        ↑
                      </button>
                      <button
                        onClick={() => reorderSponsor(i, 1)}
                        disabled={i === sponsors.length - 1}
                        style={styles.arrowButton}
                      >
                        ↓
                      </button>
                    </td>

                    <td style={styles.tableCell}>
                      <button
                        onClick={() => handleEditSponsor(sponsor)}
                        style={styles.editButton}
                      >
                        Edit
                      </button>
                    </td>
                    <td style={styles.tableCell}>
                      <button
                        onClick={() => confirmDeleteSponsor(sponsor)}
                        style={styles.deleteButton}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <button onClick={saveOrder} style={styles.saveButton}>
              Save Order
            </button>
          </>
        ) : (
          <p>No sponsors found for this gathering.</p>
        )}
      </div>

      <SponsorModal
        isVisible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        sponsor={selectedSponsor}
        gatheringID={gatheringID}
        fetchSponsorsData={fetchSponsorsData}
      />

      <Modal isOpen={isConfirmOpen} onClose={handleCloseModal}>
        <h3>Confirm Delete</h3>
        <p>Are you sure you want to delete this sponsor?</p>
        <button onClick={handleConfirmModal}>Delete Sponsor</button>
        <button onClick={handleCloseModal}>Cancel</button>
      </Modal>
    </div>
  );
};

const styles = {
  addButton: {
    width: "30%",
    padding: "10px",
    backgroundColor: "#2183a6",
    borderRadius: "5px",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    marginBottom: "10px",
  },
  sponsorItem: {
    marginBottom: "10px",
  },
  sponsorName: {
    fontSize: "18px",
  },
  editButton: {
    padding: "5px",
    backgroundColor: "#2183a6",
    borderRadius: "5px",
    margin: "5px",
    cursor: "pointer",
  },
  deleteButton: {
    padding: "5px",
    backgroundColor: "#F44336",
    borderRadius: "5px",
    margin: "5px",
    cursor: "pointer",
  },
  arrowButton: {
    padding: "5px",
    backgroundColor: "#2183a6",
    borderRadius: "5px",
    margin: "5px",
    cursor: "pointer",
    width: "40px",
  },
};

export default SponsorsTab;
